  /* eslint-disable */

export function ShowConfirmation(swalInit, title, text, icon, showCancelButton, confirmButtonText, cancelButtonText) {
     
    return new Promise(resolve => {
        resolve(
            swalInit.fire({
                title: title,
                text: text,
                icon: icon,
                closeOnClickOutside: false,
                closeOnEsc: false,
                allowOutsideClick: false,
                showCancelButton: showCancelButton,
                confirmButtonText: confirmButtonText,
                cancelButtonText
            }));
    });
}
export function ShowMsgAsModal(swalInit, title, text, icon, confirmButtonText, html) {
    if (!html) {
        return new Promise(resolve => {
            resolve(
                swalInit.fire({
                    title: title,
                    text: text,
                    icon: icon,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    allowOutsideClick: false,
                    showCancelButton: false,
                    confirmButtonText: confirmButtonText
                }));
        });
    }
    else {
        return new Promise(resolve => {
            resolve(
                swalInit.fire({
                    title: title,
                    html: html,
                    icon: icon,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    allowOutsideClick: false,
                    showCancelButton: false,
                    confirmButtonText: confirmButtonText
                }));
        });
    }
}

export function ShowValidationExtensionMsg(self, extensions) {

     self.$swal.fire({
        title: `${self.$t("titleOnlyValidationExtensionMsg")}  ${extensions} ${self.$t("titleRestValidationExtensionMsg") }` ,
        html: self.txtEmployersNames,
        icon: 'warning',
        showCancelButton: false,
        allowOutsideClick: false,
      
         confirmButtonText: self.$t("OkMsg")
    })
}
export function ShowValidationLimitMsg(self, limit) {

    self.$swal.fire({
        title: `${self.$t("titleOnlyValidationLimitMsg")}  ${limit} ${self.$t("titleRestValidationLimitMsg")}`,
        html: self.txtEmployersNames,
        icon: 'warning',
        showCancelButton: false,
        allowOutsideClick: false,

        confirmButtonText: self.$t("OkMsg")
    })
}
export function ShowMessage(swalInit, msg, icon) {

    var css = "show-message";
    const lang = localStorage.getItem('Public_lang') || 'ar-sa';
    if (lang == 'en-us')
        css = "show-message";
    else
        css = "show-messageAR";

    swalInit.fire({
        text: msg,
        icon: icon,
        toast: true,
        showConfirmButton: false,
        position: 'bottom',
        customClass: {
            container: css,
        },
        timer: 3000,
        timerProgressBar: true,
    });
}

export function ShowMessageWithCloseAction(swalInit, title,msg, icon,closeAction) {
    var css = "show-message";
    const lang = localStorage.getItem('Public_lang') || 'ar-sa';
    if (lang == 'en-us')
        css = "show-message";
    else
        css = "show-messageAR";
    swalInit.fire({
        title: title,
        text: msg,
        icon: icon,
        customClass: {
            container: css,
        },
			showCloseButton: true,
			didClose: function () {
                window.location.href = closeAction;
			}
    });
}

export function ShowMessageWithTitle(swalInit, title, msg, icon) {

    ShowConfirmation(swalInit, title, msg, icon, false, 'OK');
   //return swalInit.fire({
   //     title: title,
   //     text: msg,
   //    icon: icon,
   //    customClass: {
   //        container: 'show-message',
   //    },
   //     showCloseButton: true
   // });
}

export function ShowConfirmMessageWithTitle(swalInit, title, msg, icon, ok) {
     
    return ShowConfirmation(swalInit, title, msg, icon, false, ok);
}

export function ShowHtmlMessage(swalInit, msg, icon) {
    var css = "show-message";
    const lang = localStorage.getItem('Public_lang') || 'ar-sa';
    if (lang == 'en-us')
        css = "show-message";
    else
        css = "show-messageAR";

    swalInit.fire({
        text: msg,
        icon: icon,
        html: msg,
        toast: true,
        showConfirmButton: false,
        position: 'bottom',
        timer: 3000,
        customClass: {
            container: css,
        },
        timerProgressBar: true,
    });
}
export function ShowActiveConfirmation(data , swalInit, isEnabled, name) {

    var text, confirmButtonText = '';
    if (isEnabled) {
        text = data.$t('showActiveConfirmationEnableText')  + name + '!';
        confirmButtonText = data.$t('showActiveConfirmationEnableButtonText');
    }
    else {
        text = data.$t('showActiveConfirmationDisableText') + name + '!';
        confirmButtonText = data.$t('showActiveConfirmationDisableButtonText');
    }

    return new Promise(resolve => {
        var title = data.$t('showActiveConfirmationTitle') ;
       
        var icon = 'warning';
        var showCancelButton = true; 
        resolve(
            ShowConfirmation(swalInit, title, text, icon, showCancelButton, confirmButtonText, data.$t('showActiveConfirmationCancelButtonText'))
        );

    });
}
//by azeza to make generic confirm massege
export async function ShowConfirmationCommon(swalInit, actionName, name) {
    var title = 'Are you sure?';
    var text = 'You are going to ' + actionName + ' ' + name + '!';
    var icon = 'warning';
    var showCancelButton = true;
    var confirmButtonText = 'Yes, ' + actionName + ' it!';
    return swalInit.fire({
        title: title,
        text: text,
        icon: icon,
        closeOnClickOutside: false,
        closeOnEsc: false,
        allowOutsideClick: false,
        showCancelButton: showCancelButton,
        confirmButtonText: confirmButtonText
    });
}

    export async function ShowDeleteConfirmationCommon(self, name) {

        var title = self.$t('confirmationCommonTitle');
        var text = self.$t('confirmationCommonText')   + name + ' !';
        var icon = 'warning';
        var showCancelButton = true;
        var confirmButtonText = self.$t('confirmationCommonDeleteButton') ;
        return self.$swal.fire({
            title: title,
            text: text,
            icon: icon,
            closeOnClickOutside: false,
            closeOnEsc: false,
            allowOutsideClick: false,
            showCancelButton: showCancelButton,
            confirmButtonText: confirmButtonText,
            cancelButtonText: self.$t('Cancel')
        }); 
    //return new Promise(resolve => {
    //    var title = 'Are you sure?';
    //    var text = 'You are going to ' + actionName + ' ' + name + '!';
    //    var icon = 'warning';
    //    var showCancelButton = true;
    //    var confirmButtonText = 'Yes, ' + actionName + ' it!';
    //    resolve(
    //        ShowConfirmation(swalInit,title, text, icon, showCancelButton, confirmButtonText)
    //    );
     
}
export function ShowDeleteConfirmation(swalInit) {
    return new Promise(resolve => {
        var title = 'Are you sure?';
        var text = 'You are going to delete !' ;
        var icon = 'warning';
        var showCancelButton = true;
        var confirmButtonText = 'Yes, delete it!';
        resolve(
            ShowConfirmation(swalInit,title, text, icon, showCancelButton, confirmButtonText)
        );

    });
}

export function ShowSuccessMsg(swalInit,msg) {
    ShowMessage(swalInit ,msg,'success');
}
export function ShowWarningMsg(swalInit,msg) {
    ShowMessage(swalInit, msg,'warning');
}
export function CheckJsonResponse(response, successMethod, errorMethod, successParam, errorParam, ishtml, swalInit) {
     
    var result = response;     
    if (ishtml) {
        if (successMethod != undefined) {
            if (successParam != undefined)
                successMethod(successParam);
            else
                successMethod();
        }
    }
    else {
    if (response.responseJSON)
        result = response.responseJSON;

    if (result.isSuccess) {
        if (successMethod != undefined)  {
            if (successParam != undefined)
                successMethod(successParam);
            else
                successMethod();
        }
    }
    else {
        ShowErrorMsg(swalInit,result.error);
        if (errorMethod != undefined) {
            if (errorParam != undefined) {
                errorMethod(errorParam);
            }
            else {
                errorMethod();
            }
        }
        }
    }
}

export function ShowErrorMsg(swalInit,msg) {
    ShowHtmlMessage(swalInit,msg, 'error');
}
 
export function AddLoading(btn,self) {
   return new Promise(resolve => {
                    btn.disabled = true;
                    btn.innerHTML = "<i class='fas fa-spinner-third spinner mr-2'></i> " + self.$t('loading');
                    btn.classList.add("disabled");
                    resolve(true);
    });
}

export function RemoveLoading(btn) {
 return new Promise(resolve => {
                    var text = btn.getAttribute("data-initial-text");
                    btn.disabled = false;
                    btn.innerHTML = "<i class='fas fa-solid fa-arrow-right me-2'></i>" + text;
                    btn.classList.remove("disabled");
                    resolve(true);
                });
}
 
export function escapeAttributeValue(value) {
    // As mentioned on http://api.jquery.com/category/selectors/
    return value.replace(/([!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, "\\$1");
}
 
export function firstLetterToLowerCase(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
 

export function isEmpty(str) {
    return (!str || str.length === 0 || str === 'undefined' || str === undefined || str === null || Number(str.length) === 0 || str === '0' );
}
export function GetDateNow() {
    var d = new Date();

    var month = d.getMonth() + 1;
    var day = d.getDate();

    var output =
        (month < 10 ? '0' : '') + month + '/' +
        (day < 10 ? '0' : '') + day + '/' +
        d.getFullYear();
    return output;
}
// by azeza 
export function GetIdsFromSelect2Multi(vSelect2) {
    var Selected = vSelect2.find(':selected');
    var Names = '';
    for (var i = 0; i < Selected.length; i++) {
        if (Names != '')
            Names += ',';
        Names += Selected[i].value;
    }
    return Names;
}
export function isValidDate(str) {
    return !isNaN(Date.parse(str));
}

 
//#endregion

export function validateUrl(Url)   // return true or false.
{
    var urlregex = new RegExp(
        "^(http:\/\/www.|https:\/\/www.|ftp:\/\/www.|www.){1}([0-9A-Za-z]+\.)");
    return urlregex.test(Url);
}
//#region export 2 CSV
export function export2csv(tableName) {
    let data = "";
    const tableData = [];
    const rows = document.querySelectorAll("[id^='" + tableName + "'] tr");
    for (const row of rows) {
        const rowData = [];
        for (const [index, column] of row.querySelectorAll("th:not(.action), td:not(.action)").entries()) {
            // To retain the commas in the "Description" column, we can enclose those fields in quotation marks.
            if ((index + 1) % 3 === 0) {
                rowData.push('"' + column.innerText + '"');
            } else {
                rowData.push(column.innerText);
            }
        }
        tableData.push(rowData.join(","));
    }
    data += tableData.join("\n");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([data], { type: "text/csv" }));

    a.setAttribute("download", "SCFHSHealthAcademyExport.csv");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}


export function CheckValidArabicKey(key)   // return true or false.
{
     
    var validKeys = [8, 13, 32, 46,48,57,111, 189]; 
    return validKeys.includes(key);
}

export function CheckNotValidEnglishKey(keyCode)   // return true or false.
{
     
    var validKeys = [8, 13, 32, 46, 189, 191];
    return validKeys.includes(key);
}

export function CheckSpecialChar(keyCode)   // return true or false.
{
 
    var validKeys = [33,35,36,37,38,42,43,64,94,187,123];
    return validKeys.includes(keyCode);
}

//#endregion